module.exports = __webpack_public_path__ + "static/media/mood.95fc8515.jpeg";